// dependencies
import React, { useState } from "react";

// containers
import BookingDatePickerContainer from "@cloudspire/legacy-resources/src/containers/BookingDatePicker";

// libraries
import { fromDate } from "@cloudspire/legacy-resources/src/libraries/EnhancedDate";

type PropsType = {
  roomReference: string;
  channelId: string;
};

const ReadOnlyBookingDatePicker: React.FunctionComponent<PropsType> = (
  props
) => {
  const { roomReference, channelId } = props;

  const [date, setDate] = useState(fromDate().startOfDays());

  return (
    <BookingDatePickerContainer
      date={date}
      roomReference={roomReference}
      channelId={channelId}
      start={null}
      end={null}
      readOnly={true}
      shouldRenderLegend={false}
      onChangeDate={setDate}
    />
  );
};

export default ReadOnlyBookingDatePicker;
